module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "top"
    }
  }, [(_vm.hasError) ? _c('project-error') : (_vm.hasFinished) ? _c('project-finished') : (_vm.projectIsRunning) ? _c('project-progress') : _c('no-project-running')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cf4f3b4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-view.vue
// module id = 709
// module chunks = 1